"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["children", "colIndex", "columnHeader", "options", "dataIndex", "rowIndex", "className", "print", "firstIcon", "lastIcon"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      // width: '55.8em',
    },
    icon: {
      // borderLeft: '1px solid #CFCFCC',
      // borderRight: '1px solid #CFCFCC'
    },
    firstIcon: {
      borderLeft: '1px solid #CFCFCC'
    },
    lastIcon: {
      borderRight: '1px solid #CFCFCC'
    },
    cellHide: {
      display: 'none'
    },
    simpleHeader: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'inline-block',
      fontWeight: 'bold',
      width: '100%',
      boxSizing: 'border-box'
    }),
    simpleCell: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'inline-block',
      width: '100%',
      boxSizing: 'border-box'
    }),
    stackedHeader: {
      verticalAlign: 'top'
    },
    stackedCommon: _defineProperty({}, theme.breakpoints.down('sm'), {
      display: 'inline-block',
      fontSize: '16px',
      height: 'auto',
      width: 'calc(50%)',
      boxSizing: 'border-box',
      '&:last-child': {
        borderBottom: 'none'
      },
      '&:nth-last-child(2)': {
        borderBottom: 'none'
      }
    }),
    stackedParent: _defineProperty({}, theme.breakpoints.down('sm'), {
      display: 'inline-block',
      fontSize: '16px',
      height: 'auto',
      width: 'calc(100%)',
      boxSizing: 'border-box'
    }),
    cellStackedSmall: _defineProperty({}, theme.breakpoints.down('sm'), {
      width: '50%',
      boxSizing: 'border-box'
    }),
    responsiveStackedSmall: _defineProperty({}, theme.breakpoints.down('sm'), {
      width: '50%',
      boxSizing: 'border-box'
    }),
    responsiveStackedSmallParent: _defineProperty({}, theme.breakpoints.down('sm'), {
      width: '100%',
      boxSizing: 'border-box'
    })
  };
}, {
  name: 'MUIDataTableBodyCell'
});
function TableBodyCell(props) {
  var _ref, _ref2, _ref3;
  var classes = useStyles();
  var children = props.children,
    colIndex = props.colIndex,
    columnHeader = props.columnHeader,
    options = props.options,
    dataIndex = props.dataIndex,
    rowIndex = props.rowIndex,
    className = props.className,
    print = props.print,
    firstIcon = props.firstIcon,
    lastIcon = props.lastIcon,
    otherProps = _objectWithoutProperties(props, _excluded);
  var onCellClick = options.onCellClick;
  var handleClick = (0, _react.useCallback)(function (event) {
    onCellClick(children, {
      colIndex: colIndex,
      rowIndex: rowIndex,
      dataIndex: dataIndex,
      event: event
    });
  }, [onCellClick, children, colIndex, rowIndex, dataIndex]);

  // Event listeners. Avoid attaching them if they're not necessary.
  var methods = {};
  if (onCellClick) {
    methods.onClick = handleClick;
  }
  var cells = [/*#__PURE__*/_react.default.createElement("div", {
    key: 1,
    className: (0, _classnames.default)((_ref = {
      lastColumn: colIndex === 2
    }, _defineProperty(_ref, classes.root, true), _defineProperty(_ref, classes.cellHide, true), _defineProperty(_ref, classes.stackedHeader, true), _defineProperty(_ref, classes.stackedCommon, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty(_ref, classes.cellStackedSmall, options.responsive === 'stacked' || options.responsive === 'stackedFullWidth' && (options.setTableProps().padding === 'none' || options.setTableProps().size === 'small')), _defineProperty(_ref, classes.simpleHeader, options.responsive === 'simple'), _defineProperty(_ref, 'datatables-noprint', !print), _ref), className)
  }, columnHeader), /*#__PURE__*/_react.default.createElement("div", _extends({
    key: 2,
    className: (0, _classnames.default)((_ref2 = {}, _defineProperty(_ref2, classes.root, true), _defineProperty(_ref2, classes.stackedCommon, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty(_ref2, classes.responsiveStackedSmall, options.responsive === 'stacked' || options.responsive === 'stackedFullWidth' && (options.setTableProps().padding === 'none' || options.setTableProps().size === 'small')), _defineProperty(_ref2, classes.simpleCell, options.responsive === 'simple'), _defineProperty(_ref2, 'datatables-noprint', !print), _ref2), className)
  }, otherProps), children)];
  var innerCells;
  if (['standard', 'scrollMaxHeight', 'scrollFullHeight', 'scrollFullHeightFullWidth'].indexOf(options.responsive) !== -1) {
    innerCells = cells.slice(1, 2);
  } else {
    innerCells = cells;
  }
  return /*#__PURE__*/_react.default.createElement(_TableCell.default, _extends({}, methods, {
    className: (0, _classnames.default)((_ref3 = {}, _defineProperty(_ref3, classes.root, true), _defineProperty(_ref3, classes.icon, options.icon), _defineProperty(_ref3, classes.firstIcon, firstIcon), _defineProperty(_ref3, classes.lastIcon, lastIcon), _defineProperty(_ref3, classes.stackedParent, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty(_ref3, classes.responsiveStackedSmallParent, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth' && (options.setTableProps().padding === 'none' || options.setTableProps().size === 'small')), _defineProperty(_ref3, classes.simpleCell, options.responsive === 'simple'), _defineProperty(_ref3, 'datatables-noprint', !print), _ref3), className)
  }, otherProps), innerCells);
}
var _default = TableBodyCell;
exports.default = _default;